import React from 'react';
import { Toaster } from 'react-hot-toast';
import { Footer } from './Layout';
import HeaderAdmin from '../layout/HeaderAdmin'
import useMediaQuery from '../Hooks/useMediaQuery';
import userDefault from '../static/images/user_default.png';
import LinkButton from '../utils/LinkButton';
import { useHistory } from 'react-router-dom';

const LayoutAdmin = ({ children }) => {
    const isMobile = useMediaQuery("(max-width: 576px)");

    const history = useHistory();

    function logOut() {
        localStorage.clear();
        history.push("/");
    }

    return (
        <div className="profile admin-profile">
            <Toaster />
            <HeaderAdmin />

            {isMobile && <HeaderMobile />}

            <div className='container mb-3 mt-3' style={{ height: "100vh" }}>

                <div className='card border-radius' style={{ height: "95vh", position: "relative" }}>

                    {!isMobile && <Sidebar />}
                    <div id='admin-profile-wrapper' className='card-body admin-profile-wrapper' style={{ overflowY: "auto" }}>
                        {children}
                    </div>

                </div>

            </div>

            <Footer />
        </div>
    )
};

const Sidebar = () => {


    return (
        <>
            <aside className='admin-side border-radius'>
                <Avatar />

                <ul className="list-group list-group-flush mt-3">
                    <Link to="/admin/users/pending" >Pendientes</Link>
                    <Link to="/admin/users" >Usuarios</Link>
                    <Link to="/admin/users/denied" >No Aprobados</Link>
                    <Link to="/admin/reports" >Reportes</Link>
                    <Link to="/admin/insignias">Cargar Insignias</Link>
                </ul>
            </aside>
        </>
    )
}

const Link = ({ children, ...rest }) => {

    return (
        <li className="list-group-item" style={{ background: "transparent", padding: "0" }}>
            <LinkButton className="link-button-admin" {...rest}>{children}</LinkButton>
        </li>
    )
}

const HeaderMobile = () => {

    const history = useHistory();

    return (
        <>
            <div className='container mobile-menu'>
                <div className='row'>
                    <div className="col-6 button" onClick={() => history.push("/admin/users/pending")}>
                        Pendientes
                    </div>
                    <div className="col-6 button" onClick={() => history.push("/admin/users")}>
                        Usuarios
                    </div>
                    <div className="col-6 button" onClick={() => history.push("/admin/users/denied")}>
                        No Aprobados
                    </div>
                    <div className="col-6 button" onClick={() => history.push("/admin/reports")}>
                        Reportes
                    </div>
                </div>
            </div>
        </>
    )
}


const Avatar = ({ name = "" }) => {

    return (
        <div style={{
            width: "20vh",
            height: "20vh",
            background: "#fff",
            margin: "auto"
        }}
            className="border-radius d-flex justify-content-center align-items-center"
        >
            <img src={userDefault} width="15vh" height="15vh" className='admin-user' alt="user-default" />
        </div>
    )
}
export default LayoutAdmin;